import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact, { ReactAppOrParcel } from 'single-spa-react';

import { FeatureFlagsProvider } from '@project44/feature-flags';
import { ErrorPage, Skeleton } from '@project44/shared-components';

import { ISinglePageApplication } from '../interface';

export abstract class SinglePageApplicationClient {
  protected abstract readonly i18nClient: ISinglePageApplication['i18nClient'];
  protected abstract readonly RootComponent: ISinglePageApplication['RootComponent'];

  public readonly composeSinglePageApplication = (): ReactAppOrParcel<{
    [i: string]: never;
  }> => {
    return singleSpaReact({
      React,
      ReactDOM,
      rootComponent: this.renderRootComponent,
      errorBoundary: ErrorPage,
    });
  };

  public readonly renderRootComponent: React.FC = (props) => {
    return (
      <FeatureFlagsProvider loadingComponent={<Skeleton />}>
        <this.i18nClient.renderWithTranslations
          children={<this.RootComponent {...props} />}
        />
      </FeatureFlagsProvider>
    );
  };
}
